import { render, staticRenderFns } from "./manageSafetyForms.vue?vue&type=template&id=49b72414"
import script from "./manageSafetyForms.vue?vue&type=script&lang=js"
export * from "./manageSafetyForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports